import { Directive, ElementRef, Input, AfterContentChecked, OnChanges } from '@angular/core';

@Directive({ selector: '[bizFocus]' })
export class AutoFocusDirective implements AfterContentChecked, OnChanges {
    @Input() bizFocus: boolean;
    /**
    * Can be used to trigger the focus to be given again. Eg. set this value to new Date().getMilliseconds() when focus needs to be given again.
    */
    @Input() bizFocusTriggerChange: any;
    element: HTMLElement;

    constructor($element: ElementRef) {
        this.element = $element.nativeElement;
    }

    ngAfterContentChecked() {
        this.giveFocus();
    }

    ngOnChanges(changes: any) {
        if (changes.bizFocus || changes.bizFocusTriggerChange) {
            this.focusAlreadyGiven = false;
            this.giveFocus();
        }
    }

    focusAlreadyGiven = false;
    giveFocus() {
        if (this.bizFocus && !this.focusAlreadyGiven) {
            this.element.focus();
            this.focusAlreadyGiven = true;
        }
    }
}